import React from 'react'
import { Code } from 'react-content-loader'

const RenderingLoader = () => (
  <Code height={150} style={{ width: '100%', padding: '16px' }} />
)

export default RenderingLoader
